import { IUiIcon } from '../../../types/ui'

export const IconSearch = (
	{
		size = 24,
		imgSize= 24,
		fill = "none",
		stroke = "currentColor"
	}: IUiIcon
) => (
	<svg xmlns="http://www.w3.org/2000/svg"
	     width={`${size}px`}
	     height={`${size}px`}
	     viewBox={`0 0 ${imgSize} ${imgSize}`}
	     fill={fill}
	     stroke={stroke}
	     strokeWidth="2"
	     strokeLinecap="round"
	     strokeLinejoin="round"
	     className="feather feather-search"
	     // style={{ stroke: '#8c9097', width: '20px' }}
	>
		<circle cx="11" cy="11" r="8"></circle>
		<line x1="21" y1="21" x2="16.65" y2="16.65"></line>
	</svg>
)